
import axios, { AxiosInstance } from 'axios';
import { getExhibitionHeader } from "../utils/exhibitionContext";

export interface Standcategory {
  id: number;
  name: string;
  num_representatives: number;
  num_cars: number;
  status: boolean;
}

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000",
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Dynamically attach token before each request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    Object.assign(config.headers, getExhibitionHeader());
    }
    return config;
  },
  (error) => Promise.reject(error)
);


interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  total_pages: number;
  current_page: number;
  page_size: number;
  results: T[];
}

const StandCategoryService = {
  getAll: async (): Promise<PaginatedResponse<Standcategory>> => {
    const response = await api.get('/api/exhibitions/stand-categories/');
    return response.data;
  },

  async create(data: Omit<Standcategory, 'id'>): Promise<Standcategory> {
    const response = await api.post('/api/exhibitions/stand-categories/create/', data);
    return response.data;
  },

  async update(id: number, data: Omit<Standcategory, 'id'>): Promise<Standcategory> {
    const response = await api.put(`/api/exhibitions/stand-categories/${id}/update/`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/api/exhibitions/stand-categories/${id}/delete/`);
  },
};

export default StandCategoryService;
